<!-- <div>检测异常统计</div></div> -->
<template>
  <div class="fuzzy-matching-box">
    <div class="fuzzy-matching-top">
      <!-- <h1 class="titleStyle">通话时长统计</h1> -->
      <!-- <el-row class="top-first-line">
        <el-col :span="5">
            <el-form-item label="IMEI:">
              <el-input v-model="Dform.titleValue" placeholder=''></el-input>
            </el-form-item>
        </el-col >
        <el-col :span="5">
            <el-form-item label="姓名:">
              <el-input v-model="Dform.schoolValue" placeholder=''></el-input>
            </el-form-item>
        </el-col >
        <el-col :span="5">
        </el-col >
        <el-col :span="5">
        </el-col >
  
      </el-row> -->
      <el-row class="top-first-line the-second-line">
        <el-col :span="5">
            <el-form-item label="IMEI:">
              <el-input v-model="Dform.imei" placeholder=''></el-input>
            </el-form-item>
        </el-col >
        <el-col :span="5">
            <el-form-item label="电量:">
              <el-input v-model="Dform.powerConsumption" placeholder='请输入0-100的值'></el-input>
            </el-form-item>
        </el-col >
          <el-col :span="5">
            <el-form-item label="开始时间:">
              <el-date-picker
                  v-model="Dform.startTime"
                  type="datetime"
                  format="YYYY-MM-DD HH:mm:ss"
                  value-format="YYYY-MM-DD HH:mm:ss"
                  placeholder="选择日期时间">
              </el-date-picker>
            </el-form-item>
        </el-col >
          <el-col :span="5">
            <el-form-item label="结束时间:">
              <el-date-picker
                  v-model="Dform.terminalTime"
                  type="datetime"
                  format="YYYY-MM-DD HH:mm:ss"
                  value-format="YYYY-MM-DD HH:mm:ss"
                  placeholder="选择日期时间">
              </el-date-picker>
            </el-form-item>
          </el-col >
   
        <div class="query-button">
          <el-button type="primary"  @click="inquiryClick">查询</el-button>
        <el-button type="primary" @click="exportClick">电量异常统计导出</el-button>
        </div>

      </el-row>
    </div>

    <div class="fuzzy-matching-bottom">
      <el-row class="list">
        <el-table
          stripe
         :border="true"
         v-loading="loading"
         :header-cell-style="{background:'#EDF6FF',color:'#000',}"
          ref="multipleTable"
          :data="tableData"
          tooltip-effect="dark"
          style="width: 100%"
          class="table-Style"
          @selection-change="handleSelectionChange"
          @sort-change="sort_change">
          <el-table-column
            prop="imei"
            label="IMEI"
            >
          </el-table-column>
          
          <el-table-column
            prop="name"
            label="姓名"
            >
          </el-table-column>
          
          <el-table-column
            prop="powerConsumption"
            label="耗电量"
            >
          </el-table-column>
          <el-table-column
            prop="appVersion"
            label="软件版本号"
            >
          </el-table-column>
          <el-table-column
            prop="endTime"
            label="最小电量时间"
            >
          </el-table-column>
          <el-table-column
            prop="startTime"
            label="最大电量时间"
            >
          </el-table-column>
          <el-table-column
            prop="userName"
            label="所属单位"
            >
          </el-table-column>
        </el-table>
        <div class="block-fenye" >
          <el-pagination
              :small="small"
              :disabled="disabled"
              :background="background"
              layout="prev, pager, next, jumper"
              :total="total"
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
            />
        </div>
      </el-row>
    </div>
  </div>
</template>

<script>
import { 
  dianliangApi,
  electricity,
} from '@/assets/api/api'
import { ArrowUp,ArrowDown } from "@element-plus/icons-vue"; // 图标
// import { log } from 'echarts/types/src/util/log.js';
export default {
  components: {
    ArrowUp,ArrowDown
  },         
  data () {
    return {
      loading:true,
      Dform: {
          imei: '',
          powerConsumption: '',
          startTime : '',
          terminalTime: '',
      },
      ArrowShow: true ,
      matchTime: [],
      tableData: [],
      multipleSelection: [],
      reviseShow: false,
      LeadingInShow: false,
      pageInfo: {
        page: 1,
        pageSize: 10,
      },
      total: 0
    }
  },
  created() {
     this.callDurationClick()
  },
  methods: {
    exportClick() {
      let params = {
        endTime:this.Dform.terminalTime,
        startTime:this.Dform.startTime,
        imei:this.Dform.imei,
        page: this.pageInfo.page,
        pageSize: this.pageInfo.pageSize,
        powerConsumption:this.Dform.powerConsumption,
        userId: JSON.parse(localStorage.getItem('user')).id,
      }
      electricity(params).then((res)=> {
        console.log(res,'导出')
        this.handleExport(res.data,'电量异常统计.xls')
      }).catch((err)=> {
        console.log(err)
      })
    },
    handleExport(data,name) {
        // 动态创建iframe下载文件
        let fileName = name;
        if (!data) {
            return;
        }
        let blob = new Blob([data], { type: "application/octet-stream" });
        console.log(blob);
        if ("download" in document.createElement("a")) {
            // 不是IE浏览器
            let url = window.URL.createObjectURL(blob);
            let link = document.createElement("a");
            link.style.display = "none";
            link.href = url;
            link.setAttribute("download", fileName);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link); // 下载完成移除元素
            window.URL.revokeObjectURL(url); // 释放掉blob对象
        } else {
            // IE 10+
            window.navigator.msSaveBlob(blob, fileName);
        }
    },
    inquiryClick( ) {
      this.callDurationClick()
    },
    callDurationClick () {
      let params = {
        endTime:this.Dform.terminalTime,
        startTime:this.Dform.startTime,
        imei:this.Dform.imei,
        powerConsumption:this.Dform.powerConsumption,
        page: this.pageInfo.page,
        pageSize: this.pageInfo.pageSize,
        userId: JSON.parse(localStorage.getItem('user')).id,
      }
      dianliangApi(params).then((res)=> {
        console.log(res.data.data.totalCount,66);
        
        this.tableData = res.data.data.data
        this.total = res.data.data.totalCount
        this.loading = false
      }).catch((err)=> {
          console.log(err);
      })
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
      console.log(this.multipleSelection,val,'this.multipleSelection');
    },
    //统计时长用的暂时无用
    // upwardClick () {
    //   console.log('向上');
    //   this.ArrowShow = false
    // },
    // downwardClick() {
    //   console.log('向下');
    //   this.ArrowShow = true
    // },
    handleSizeChange (val) {
      console.log(`${val} items pr page`)
    },
    handleCurrentChange (val) {
      this.pageInfo.page = val
      this.callDurationClick()
    },
   
  },
  filters: {
  }
}
</script>

<style lang='scss' scoped>
.fuzzy-matching-box {
  width: 100%;
  height:  95%;
  border-radius: 8px;
  .title-top {
  }
  .fuzzy-matching-top {
    height: 100px ;
    background-color: #fff;
    border-radius: 15px;
    display: flex;
    align-content: space-around;  
    align-items: center;
    

    .titleStyle{
      width: 25%;
      margin-left: 40px;
      font-size: 20px;
      font-weight: 700;
    }

      /deep/ {
        .el-input--small .el-input__wrapper{
            margin-right: 15px;
            border-radius: 15px
            ;
          }
        .el-select--small {
            width: 100%;

        }
        .el-form-item--small .el-form-item__label {
          width: 110px;
          text-align: right;
          height: 35px;
          line-height: 35px;     
          font-weight: 700;     
          font-size: 16px;
        }
        .el-form-item {
          width: 109%;
      
          margin-left: 15px;
        }
        .el-input {
          width: 100%;
          height: 35px;

        }
       
    }
    .the-second-line {
      margin-top: 15px;
      position: relative;
      .query-button {
        position: absolute;
        right: -60px;
        .el-button {
          padding: 16px 24px;
        // background-color: #1BC896;
        border-radius: 15px;
        }
      }
    }
    
  }
  
    /deep/ {
      .el-range-editor--small.el-input__wrapper {
          height: 35px;
          line-height: 35px;  
        

      
   
    }
  }
  .fuzzy-matching-bottom {
    // height: calc(100% - 170px);
    height: 85%;
    overflow: auto;
    position: relative;
    padding: 0px 20px;
    padding-top: 25px;
    margin-top: 15px;
    background-color: #fff;
    border-radius: 15px;
    .table-Style{
      font-size: 16px;
      // border-radius: 15px;
    }
    .top-first-line {
      height: 45px;
      line-height: 45px;
        /deep/ .tip-button {
          padding: 14px 14px;
          margin: 0px 3px;
        }
      .import-export-button {
        position: absolute;
        right: 20px;
        /deep/ .el-button--small {
          padding: 16px 24px;
          border: 1px solid #569CFF;
          color: #569CFF;
        }
      }
    }
    .list {
      position: relative;
      // margin-top: 10px;
      padding-bottom: 50px;
     .fenye {
      // float: right;
      text-align: center;
     }
      /deep/ {
        // .el-checkbox.el-checkbox--small .el-checkbox__inner {
        //   width: 18px;
        //   height: 18px;
        // }
        // .el-checkbox:last-of-type {
        //   margin-right: -1px;
        // }
        .el-table td.el-table__cell, .el-table th.el-table__cell.is-leaf {
          // border: 0px;
        }
        .el-table tr {
          height: 40px;
          cursor: pointer;
          font-size: 16px;
          color: black;
          user-select: initial;
         
        }
         .manipulate {
          color: red;
          margin-right:15px;
          cursor: pointer;
          // user-select: none;
        }
        .confirm,.duplicate,.revise {
          color:#1677FF;
          
        }
        .el-table th.el-table__cell>.cell {
          text-align: center;
          font-weight: 700;
        }
        .el-table td.el-table__cell, .fuzzy-matching-box .fuzzy-matching-bottom .list[data-v-1ddf37d1] .el-table th.el-table__cell.is-leaf {
          text-align: center;
        }
      }
      .block-fenye {
        // float: right;
        position: absolute;
        bottom: 0px;
        left: 50%;
        transform: translate(-50%,0);
        
      }
    }
  }
  
}
</style>